import { Component, type ErrorInfo, type ReactNode } from 'react';
import { myErrorService } from 'v5/services/front/ErrorService/ErrorService.connected';
import { AppCrashErrorScreen } from './AppCrashErrorScreen';

type Props = {
  children: ReactNode;
};

type State = {
  error: Error | null;
  errorInfo: ErrorInfo | null;
};

/**
 * Root-level boundary for uncaught render errors (white screen of death).
 * Reports via {@link myErrorService} and shows {@link AppCrashErrorScreen}.
 */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null, errorInfo: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.setState({ errorInfo });
    myErrorService.reportError('app-crash', error);
    if (process.env.NODE_ENV !== 'production') {
      console.error('AppErrorBoundary', error, errorInfo.componentStack);
    }
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <AppCrashErrorScreen
          error={this.state.error}
          errorInfo={this.state.errorInfo}
        />
      );
    }
    return this.props.children;
  }
}
